import React, { useEffect } from "react";
import { Form } from "antd";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";

/**
 * Renders a grid of permission checkboxes.
 * - “All Rights” and “No Rights” are always visible.
 * - Individual permissions are hidden when:
 *    • “No Rights” is checked in this group, OR
 *    • that individual is checked in the opposite group.
 */
export default function PermissionGroup({ form, prefix, heading, permissionItems }) {
  // Watch this group's nested values
  // console.log(form.getFieldsValue(),"permissionGroup");
  const groupVals = Form.useWatch(prefix, form) || {};
  // Watch the opposite group's nested values
  const opposite = prefix === "allowSetting" ? "denySetting" : "allowSetting";
  const otherVals = Form.useWatch(opposite, form) || {};

  // Find the special constants
  const allConst  = permissionItems.find(i => i.defaultString === "All Rights")?.constantName;
  const noneConst = permissionItems.find(i => i.defaultString === "No Rights")?.constantName;

  const noneChecked = Boolean(groupVals[noneConst]);
useEffect(()=>{
console.log({permissionItems,prefix})
})
  return (
    <StyledGridCol lg={12}>
      <StyledSectionHeading className="unstyled-line">
        {heading}
      </StyledSectionHeading>
      <StyledGridRow gutter={16}>
        {permissionItems.map(item => {
          const { constantName, defaultString } = item;
          const isAll       = constantName === allConst;
          const isNone      = constantName === noneConst;
          const isIndividual = !isAll && !isNone;

          // Hide individual if no-rights here OR that individual is checked in other group
          const shouldHide = isIndividual && ( Boolean(otherVals[constantName]));
          if(item.constantName === "DELETE")
          console.log({shouldHide,isIndividual,item,prefix,noneChecked,otherVals,groupVals,otherVal:otherVals[constantName]  });
          return (
            <StyledGridCol
              key={constantName}
              lg={12}
              style={{ visibility: shouldHide ? "hidden" : "visible" }}
            >
              <FormItem
                name={[prefix, constantName]}
                label={defaultString}
                layout="horizontal"
                labelPostion="label-right"
                valuePropName="checked" 
              >
                <Checkbox />
              </FormItem>
            </StyledGridCol>
          );
        })}
      </StyledGridRow>
    </StyledGridCol>
  );
}
